export default {
  methods: {
    isShowButton(name) {
      // debugger
      let flag = false
      for (let item of this.btnPremissionList) {
        if (item.name === name) {
          flag = true
        }
      }
      return flag
    },
    getBtnRole() {
      // debugger
      this.Axios.get('/api/User/GetUserBtnJurisdiction?menuID=' + this.menuId).then(res => {
        this.btnPremissionList = res.data.data
        this.isCompleted = true
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/index.js